module.exports = __webpack_public_path__ + "img/screencapture-netflix-watch-81262750-2021-10-01-22_49_20.43358ee6.png";